
import {
  w
} from '../../utils/helpers'

const frameStorage = {
  storageKey: null,
  connected: false,
  init(s) {
    this.store = s
    const f = document.createElement('iframe')

    f.src = w.app('frameStorage')
    f.style.display = 'none'
    document.body.appendChild(f)
    this.iframe = f
    this.storageKey = w.key

    window.addEventListener('message', this.listen, false)

  },
  send(type, data) {

    const payload = {
      swaychat_storage: 'client',
      key: this.storageKey,
      type,
      data
    }

    if (this.iframe && this.iframe.contentWindow)
      this.iframe.contentWindow.postMessage(JSON.stringify(payload), '*');

  },
  listen(e) {

    if (!e.data ||
      typeof e.data != 'string' ||
      /swaychat_storage/.test(e.data) == false
    ) return

    const payload = JSON.parse(e.data)
    //console.log('client',payload)

    //when connected send sync request
    if (payload.type == 'connect') {
      frameStorage.connected = true
      frameStorage.send('sync')
    }

    //when sync data received, process
    if (payload.type == 'sync')
      frameStorage.sync(payload.data)

  },
  sync(data) {
      this.store.commit('syncState', {
        synced: true,
        ...data || {}
      })
  },
  update(data) {
    if (data.uid)
      this.send('update', data)
  }
}

export default frameStorage
